import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-448a696a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ctas"
}

import { SailingStatus, Button } from '../../Atoms';
import { InfoCard } from '../../Molecules';
import { StatusDetailsTabView } from '../../Organisms';
import { RteContentType, SailingStatusType } from '../../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'SailingTabView',
  props: {
    status: {},
    statusHeading: {},
    rteContent: {},
    showAlternativeCta: { type: Boolean },
    showRefundCta: { type: Boolean },
    refundClick: { type: Function },
    findAlternativeClick: { type: Function }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StatusDetailsTabView), { "rte-content": _ctx.rteContent }, {
    header: _withCtx(() => [
      _createVNode(_unref(SailingStatus), {
        "sailing-status": _ctx.status,
        "status-text": _ctx.statusHeading
      }, null, 8, ["sailing-status", "status-text"])
    ]),
    infoCard: _withCtx(() => [
      (_ctx.status === _unref(SailingStatusType).Normal)
        ? (_openBlock(), _createBlock(_unref(InfoCard), {
            key: 0,
            "icon-name": "statusNormal",
            text: _ctx.$t('All sailings normal text'),
            lg: true,
            "background-color": '#DCF1D9'
          }, null, 8, ["text"]))
        : _createCommentVNode("", true)
    ]),
    ctas: _withCtx(() => [
      (_ctx.showAlternativeCta || _ctx.showRefundCta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.showRefundCta)
              ? (_openBlock(), _createBlock(_unref(Button), {
                  key: 0,
                  outline: true,
                  label: _ctx.$t('Request a refund'),
                  onClick: _ctx.refundClick
                }, null, 8, ["label", "onClick"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["rte-content"]))
}
}

})